import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import {
  userLoginReducer,
  userRegisterReducer,
  userDetailsReducer,
  userUpdateProfileReducer,
  userListReducer,
  devUserListReducer,
  empUserListReducer,
  userDeleteReducer,
  userUpdateReducer,
  userForgotPassReducer,
  userResetPassReducer,
} from "./reducers/userReducers";
import {
  employerBuildReducer,
  listBuildEmployerReducer,
  listAllBuildEmployerReducer,
  detailBuildEmployerReducer,
  employerHireReducer,
  listHireEmployerReducer,
  listAllHireEmployerReducer,
  updateBuildEmployerReducer,
} from "./reducers/employerReducer";
import {
  developerApplyReducer,
  developerApplyBuildReducer,
  listBuildApplyReducer,
  developerLearnReducer,
  developerDetailEditReducer,
  developerDetailReducer,
} from "./reducers/developerReducer";

const reducer = combineReducers({
  userLogin: userLoginReducer,
  userRegister: userRegisterReducer,
  userDetails: userDetailsReducer,
  userUpdateProfile: userUpdateProfileReducer,
  userList: userListReducer,
  devUserList: devUserListReducer,
  empUserList: empUserListReducer,
  userDelete: userDeleteReducer,
  userUpdate: userUpdateReducer,
  userForgotPass: userForgotPassReducer,
  userResetPass: userResetPassReducer,
  employerBuild: employerBuildReducer,
  listBuild: listBuildEmployerReducer,
  listAllBuild: listAllBuildEmployerReducer,
  listAllHire: listAllHireEmployerReducer,
  detailBuild: detailBuildEmployerReducer,
  updateBuild: updateBuildEmployerReducer,
  employerHire: employerHireReducer,
  listHire: listHireEmployerReducer,
  developerApply: developerApplyReducer,
  developerApplyBuild: developerApplyBuildReducer,
  listBuildApply: listBuildApplyReducer,
  developerLearn: developerLearnReducer,
  developerDetail: developerDetailReducer,
  developerDetailEdit: developerDetailEditReducer,
});

const userInfoFromStorage = localStorage.getItem("userInfo")
  ? JSON.parse(localStorage.getItem("userInfo"))
  : null;

const initialState = {
  userLogin: { userInfo: userInfoFromStorage },
};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
